const Footer = () => (
  <footer className="group bg-white mb-8">
    <h1 className="text-[10vw] group-hover:translate-y-4 translate-y-10 leading-[100%] uppercase font-semibold text-center bg-gradient-to-r from-gray-400 to-gray-800 bg-clip-text text-transparent transition-all ease-linear">
      Tutor Kendra
    </h1>
    {/* <section className="bg-black opacity-50 text-white h-40 relative z-10 hidden md:grid place-content-center text-2xl rounded-tr-full rounded-tl-full">
      <div>
        Start Your Journey Today!{' '}
        <a
          href="#top"
          className="underline hover:text-blue-300 transition-colors duration-200"
        >
          Inquiry Now
        </a>
      </div>
    </section> */}
  </footer>
);

export default Footer;